import { Directive, HostListener, Input } from "@angular/core";
import { NgControl } from "@angular/forms";

import { UppercaseInputValueService } from "./uppercase-input-value.service";

@Directive({
	selector: "input[obgUppercaseValue]",
})
export class UppercaseInputValueDirective {
	@Input() obgUppercaseValue = false;

	constructor(
		private ngControl: NgControl,
		private uppercaseInputValueService: UppercaseInputValueService
	) {}

	@HostListener("blur", ["$event.target.value"])
	onBlur(value: string) {
		if (this.obgUppercaseValue) {
			const uppercaseValue = this.uppercaseInputValueService.transform(value);

			this.ngControl.control?.setValue(uppercaseValue);
		}
	}
}
